import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { useUserAppContext } from '../../../contexts/UserAppContext';
import { CleaningAccessRefusal } from '../hooks/useCleaningAccess';

type CleaningAccessRefusedProps = {
  reason: CleaningAccessRefusal;
};

const CleaningAccessRefused = ({ reason }: CleaningAccessRefusedProps) => {
  const { t } = useTranslation('environmental-cleaning');
  const { logout } = useAuthenticationContext();
  const { resetApp } = useUserAppContext();

  const changeAccess = async () => {
    resetApp();
    await logout();
  };

  return (
    <Stack spacing={4} paddingY={8} alignItems="center">
      <Typography textAlign="center">{t(`access.${reason}`)}</Typography>
      <Button variant="outlined" onClick={changeAccess}>
        {t('access.changeAccess')}
      </Button>
    </Stack>
  );
};

export default CleaningAccessRefused;
